<template>
  <div :class="rootClasses">
    <img v-if="image.src && !imageHasError" :src="image.src" height="100%" v-bind="image.props" @error="onError" />
    <component :is="image.component" v-else-if="image.component" v-bind="image.props" />
    <component :is="placeholderComponent" v-else-if="isPlaceholderImage" alt="placeholder" height="16px" width="16px" />
    <BravadoText v-else variant="headline-semibold">
      {{ image.props.alt }}
    </BravadoText>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from '@nuxtjs/composition-api';
import type { BravadoSelectDropdownOptionImage } from './types';
import { ImageShape, PossibleImagePlaceholder } from './types';
import BuildingIcon from '@/assets/svg/building.vue.svg';
import PlaceholderImageIcon from '@/assets/svg/placeholder-image.vue.svg';

type BravadoSelectDropdownImageProps = {
  image: BravadoSelectDropdownOptionImage;
};

const props = defineProps<BravadoSelectDropdownImageProps>();

const imageHasError = ref(false);

function onError() {
  imageHasError.value = true;
}

const placeholder = computed(() => {
  return props.image.placeholder || PossibleImagePlaceholder.default;
});
const isPlaceholderImage = computed(() => imageHasError.value || placeholder.value !== PossibleImagePlaceholder.user);
const placeholderComponent = computed(() =>
  placeholder.value === PossibleImagePlaceholder.company ? BuildingIcon : PlaceholderImageIcon,
);
const rootClasses = computed(() => ({
  'bravado-select-dropdown-image': true,
  'bravado-select-dropdown-image--rounded': props.image.shape === ImageShape.rounded,
  'bravado-select-dropdown-image--circle': props.image.shape === ImageShape.circle,
}));
</script>

<style scoped lang="scss">
.bravado-select-dropdown-image {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: var(--theme-color-over-card);
  width: 32px;
  height: 32px;

  &--rounded {
    border-radius: 8px;
  }

  &--circle {
    border-radius: 100%;
  }
}
</style>
